import { useEffect } from 'react'
import { useSendStore } from '@/store/useSendStore'

export const useSendLogic = () => {
  const {
    // State
    type,
    isFiatMode,
    triggerShake,
    cryptoAmount,
    fiatAmount,
    selectedCurrency,
    recipient,
    note,
    isLoading,
    error,

    // Actions
    setType,
    setIsFiatMode,
    setCryptoAmount,
    setFiatAmount,
    setSelectedCurrency,
    setRecipient,
    setNote,
    setIsLoading,
    setError,
    shakeComponent,
    resetSend,
  } = useSendStore()

  // Переключение между фиатным и крипто режимом
  const toggleCurrencyMode = () => {
    setIsFiatMode(!isFiatMode)
  }

  // Валидация суммы
  const validateAmount = (amount: string): boolean => {
    const numAmount = parseFloat(amount)
    return numAmount > 0 && !isNaN(numAmount)
  }

  // Проверка, можно ли выполнить отправку/запрос
  const canSubmit = () => {
    const currentAmount = isFiatMode ? fiatAmount.amount : cryptoAmount.amount
    return validateAmount(currentAmount) && selectedCurrency && !isLoading
  }

  // Сброс ошибки при изменении суммы
  useEffect(() => {
    if (error) {
      setError(null)
    }
  }, [fiatAmount.amount, cryptoAmount.amount, error, setError])

  return {
    // State
    type,
    isFiatMode,
    triggerShake,
    cryptoAmount,
    fiatAmount,
    selectedCurrency,
    recipient,
    note,
    isLoading,
    error,

    // Computed
    canSubmit: canSubmit(),

    // Actions
    setType,
    toggleCurrencyMode,
    setCryptoAmount,
    setFiatAmount,
    setSelectedCurrency,
    setRecipient,
    setNote,
    setIsLoading,
    setError,
    shakeComponent,
    resetSend,
    validateAmount,
  }
}
